import axios from 'axios'
import store from '@/store'

let http = axios.create({
  baseURL: 'https://www.cms.jeepgrilles.co.nz/api/v1',
  headers: {'Access-Control-Allow-Origin': '*'}
})

http.interceptors.request.use(function (config) {
  const token = store.state.config.access_token
  config.headers.Authorization = token ? `Bearer ${token}` : ''
  return config
})

export default {
  // POST requests with http headers
  likePic (id) {
    let payload = {
      'user_id': id,
      'like': 1
    }
    return http.post('/like', payload)
      .then(function (response) {
        console.log('like response::', response.data)
        store.commit('updateUser', response.data)
        return response
      })
      .catch((error) => {
        return error
      })
  },
  unlikePic (id) {
    let payload = {
      'user_id': id,
      'like': 0
    }
    return http.post('/like', payload)
      .then(function (response) {
        console.log('like response::', response.data)
        store.commit('updateUser', response.data)
        return response
      })
      .catch((error) => {
        return error
      })
  },
  //
  // POST requests with no Bearer tokens
  login (params) {
    return axios.create({
      baseURL: 'https://www.cms.jeepgrilles.co.nz/api/v1',
      headers: {'Access-Control-Allow-Origin': '*'}
    }).post('/oauth/token', params)
      .then(function (response) {
        console.log('config response::', response.data.access_token)
        store.commit('login', response.data)
        return response
      })
      .catch((error) => {
        store.state.logged_in = false
        console.log('error::', error.response.data)
        return error
      })
  },
  register (params) {
    return axios.create({
      baseURL: 'https://www.cms.jeepgrilles.co.nz/api/v1',
      headers: {'Access-Control-Allow-Origin': '*'}
    }).post('/register', params)
      .then(function (response) {
        console.log('config response::', response.data.access_token)
        store.commit('login', response.data)
        return response
      })
      .catch((error) => {
        store.state.logged_in = false
        console.log('error::', error.response.data)
        return error.response.data
      })
  },
  forgot (params) {
    return axios.create({
      baseURL: 'https://www.cms.jeepgrilles.co.nz/api/v1',
      headers: {'Access-Control-Allow-Origin': '*'}
    }).post('/forgot', params)
      .then(function (response) {
        console.log('config response::', response)
        return response
      })
      .catch((error) => {
        console.log('error::', error.response.data)
        return error.response.data
      })
  },
  //
  // GET requests with no Bearer tokens
  filter (params) {
    let editedParams = '?sort=' + params.sortBy + '&name=' + params.nameSearch + '&location=' + params.location + '&mood=' + params.mood + '&page=' + params.page
    console.log('in filter', editedParams)
    return axios.create({
      baseURL: 'https://www.cms.jeepgrilles.co.nz/api/v1',
      headers: {'Access-Control-Allow-Origin': '*'}
    }).get('/gallery' + editedParams)
      .then(function (response) {
        // console.log('gallery response::', response.data)
        // store.commit('updateGallery', response.data)
        return response
      })
      .catch((error) => {
        console.log('gallery error::', error.response.data.message)
        return error
      })
  },
  pageDetails (params) {
    return axios.create({
      baseURL: 'https://www.cms.jeepgrilles.co.nz/api/v1',
      headers: {'Access-Control-Allow-Origin': '*'}
    }).get('/page/' + params)
      .then(function (response) {
        return response
      })
      .catch((error) => {
        return error
      })
  },
  getLocations () {
    return axios.create({
      baseURL: 'https://www.cms.jeepgrilles.co.nz/api/v1',
      headers: {'Access-Control-Allow-Origin': '*'}
    }).get('/locations')
      .then(function (response) {
        store.commit('updateLocations', response.data)
        return response
      })
      .catch((error) => {
        console.log('locations error::', error.response.data.message)
        return error
      })
  }
  //
  // POST requests with no Bearer tokens
  // socialLogin (params) {
  //   return axios.create({
  //     baseURL: 'https://www.cms.jeepgrilles.co.nz/api/v1',
  //     headers: {'Access-Control-Allow-Origin': '*'}
  //   }).post('/login', params)
  //     .then(function (response) {
  //       console.log('config response::', response.data.access_token)
  //       store.commit('login', response.data)
  //       console.log(store.state)
  //       return response
  //     })
  //     .catch((error) => {
  //       store.state.logged_in = false
  //       console.log('error::', error.response.data.message)
  //       return error
  //     })
  // }
}
